import React from 'react';

export const AlertInfo = () => {
  return (
    <div id="alert-info" style={{ marginTop: 0 }}>
      <div className="info-text" style={{
        width: 720,
        padding: 20,
        display: 'block',
        margin: 'auto',
        background: "#dbe2f6",
        fontSize: 17,
        borderRadius: 10,
        textAlign: "center",
        font: "14px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        fontWeight: 500
      }}>
        <span>
          Recuerda que el límite de guías por manifiesto es de 500. Por favor, tenga en cuenta esta restricción al realizar sus movimientos.
        </span>
      </div>
    </div>
  )
} 